export default __webpack_public_path__ + "static/media/Silk-Serif-Light-Italic.16814373.otf";